import api from '@/lib/api';
import { API_ENDPOINTS } from '@/constants/endpoints';
import type { ApiResponse } from '@/types';

/** One recorded call of an action, as /tool-execution-logs returns it. */
export interface ToolExecutionLog {
  id: number;
  requestId: string;
  conversationId: number | null;
  /** The conversation's helpdesk or provider ticket page; null when none can be built. */
  ticketUrl: string | null;
  /** Its latest Sentinel ticket; null when it never went through Sentinel. */
  sentinelTicketId: number | null;
  buId: number | null;
  clientId: string;
  tool: string;
  provider: string | null;
  input: unknown;
  output: unknown;
  status: 'success' | 'error';
  statusCode: number;
  errorCode: string | null;
  errorMessage: string | null;
  latencyMs: number;
  externalLatencyMs: number | null;
  idempotencyKey: string | null;
  fromIdempotencyCache: boolean;
  devMode: boolean;
  truncated: boolean;
  createdAt: string;
}

export interface ToolExecutionLogsResponse {
  logs: ToolExecutionLog[];
  pagination: { page: number; limit: number; total: number; totalPages: number };
}

export const toolExecutionLogService = {
  async list(
    provider: string,
    tool: string,
    page: number,
    limit: number,
    requestId?: string
  ): Promise<ToolExecutionLogsResponse> {
    const response = await api.get<ApiResponse<ToolExecutionLogsResponse>>(API_ENDPOINTS.TOOL_EXECUTION_LOGS.BASE, {
      params: { provider, tool, page, limit, ...(requestId && { requestId }) },
    });
    return response.data.data;
  },
};
